import { ProductType, Segment } from "../models/company-client-segmentations";
import { authFetch } from "./fetch";


const baseUrl = '/api/Admin/CompanySegmentation';
export const ICompanySegmentationsAPI = {
    getCLientTypes: async() => {
        try {
            const result = await authFetch.get(`${baseUrl}/GetClientTypes`);
            return result.data;            
        } catch (error) {
            return Promise.reject(error);
        }
    },

    getCompanyClientSegments: async(clientTypeId:number) => {
        try {
            const result = await authFetch.get(`${baseUrl}/${clientTypeId}`);
            return result;
        } catch (error) {
            return Promise.reject(error);
        }
    },

    addUpdateProductTypes: async(product: ProductType) => {
        try {
            const result = await authFetch.post(`${baseUrl}/AddUpdateProductTypes`,product);
            return result;           
        } catch (error) {
            return Promise.reject(error);
        }
    },

    addUpdateSegments: async(segments: Segment[]) => {
        try {
            const result = await authFetch.post(`${baseUrl}/AddUpdateSegmentations`,segments);
            return result;           
        } catch (error) {
            return Promise.reject(error);
        }
        
    },
    deleteSegment: async(segmentId: number) => {
        try {
            const result = await authFetch.delete(`${baseUrl}/${segmentId}`);
            return result;           
        } catch (error) {
            return Promise.reject(error);
        }
        
    }    
};